module.exports = __webpack_public_path__ + "static/media/RaisingChildren_android_1.1270f704.jpg";